<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="商品审核">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">Product Review</li>
        </ul>
      </template>
    </TitleCard>
    <div id="kt_app_main" class="app-main flex-column flex-row-fluid" v-loading="loading">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush">
            <div class="card-body">
              <div style="display: flex">
                <el-select placeholder="请选择类型" size="small" clearable v-model="params.status">
                  <el-option label="私域" value="0"/>
                  <el-option label="公域" value="1"/>
                </el-select>
                <el-input placeholder="请输入商品ID" v-model="params.id" clearable style="margin-left: 10px;width: 300px" size="small"/>
                <el-input placeholder="请输入商品名称" v-model="params.title" clearable style="margin-left: 10px;width: 300px" size="small"/>
                <el-button style="margin-left: 10px" clearable  round type="primary" size="small" @click="getSjGoodsListAll">搜索</el-button>
                <el-button round size="small" @click="resetParams">重置</el-button>
              </div>
              <el-table border :data="goodsList" style="margin-top: 20px">
                <el-table-column label="商品ID" prop="id" width="100"/>
                <el-table-column label="图片" width="100">
                  <template slot-scope="scope">
                    <el-image :src="scope.row.picUrl" alt="图片" :preview-src-list="[scope.row.picUrl]"/>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="title" width="300"/>
                <el-table-column label="分类" prop="categoryId1Name"/>
                <el-table-column label="直接购买价" prop="onePrice"/>
                <el-table-column label="开奖价" prop="salePrice"/>
                <el-table-column label="结算价" prop="costPrice"/>
                <el-table-column label="类型">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 0" type="success">私域</el-tag>
                    <el-tag v-if="scope.row.status == 1" type="warning">公域</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div style="display: flex; justify-content: space-between; align-items: center">
                      <el-button type="primary" size="mini" @click="openDialog(scope.$index)">详情</el-button>
                      <el-button v-if="scope.row.status == 0" type="warning" size="mini"
                                 @click="updateStatus(scope.row.id, 1)">调整至公域
                      </el-button>
                      <el-button v-if="scope.row.status == 1" type="success" size="mini"
                                 @click="updateStatus(scope.row.id, 0)">调整至私域
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="params.current"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="params.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  style="display: flex;justify-content: center;margin-top: 20px">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="商品详情图" width="90%">
      <div v-if="selectedIndex >= 0">
        <div class="detail-img-style" v-html="goodsList[selectedIndex].detail"></div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import {getSjGoodsListAllApi, getSjGoodsListCountApi, updateStatusApi} from "@/api/goodsManageApi";

export default {
  name: "ProductReview",
  data() {
    return {
      dialogVisible: false,
      params: {
        id:"",
        title: "",
        type: "1",
        isShow: "1",
        size: 10,
        current: 1,
        isJd: 2,
        status: "",
      },
      goodsList: [],
      loading: false,
      total: 0,
      selectedIndex: -1,
    }
  },
  filters: {},
  methods: {
    resetParams(){
      this.params = {
        id:"",
        title: "",
        type: "1",
        isShow: "1",
        size: 10,
        current: 1,
        isJd: 2,
        status: "",
      }
      this.getSjGoodsListAll()
    },
    handleSizeChange(size) {
      this.params.size = size
      this.getSjGoodsListAll()
    },
    handleCurrentChange(current) {
      this.params.current = current
      this.getSjGoodsListAll()
    },
    async getSjGoodsListAll() {
      if (this.params.id || this.params.title || this.params.status){
        this.params.current = 1
      }
      this.loading = true
      let {data} = await getSjGoodsListAllApi(this.params)
      this.goodsList = data.rows
      this.total= data.total
      this.loading = false
    },
    openDialog(index) {
      this.selectedIndex = index
      this.dialogVisible = true
    },
    async getSjGoodsPageCount() {
      let {data} = await getSjGoodsListCountApi(this.params);
      this.total = data;
    },
    async updateStatus(id, status) {
      await updateStatusApi({
        id,
        status
      })
      this.getSjGoodsListAll()
      this.$message({
        type: 'success',
        message: `${status == 2 ? '通过' : '拒绝'}成功！`
      });
    }
  },
  created() {
    this.getSjGoodsListAll()
  },
}
</script>

<style>
.detail-img-style {
  word-break: break-all;
  font-size: 14px;
}

.detail-img-style img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px auto;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

</style>